
interface BadgeProps {
  emoji: string;
  label: string;
  variant?: 'gold' | 'silver' | 'bronze' | 'default';
}

export function Badge({ emoji, label, variant = 'default' }: BadgeProps) {
  const variants = {
    gold: 'bg-gradient-to-br from-yellow-400 to-yellow-500 text-primary-dark shadow-md',
    silver: 'bg-gradient-to-br from-gray-400 to-gray-500 text-white shadow-md',
    bronze: 'bg-gradient-to-br from-amber-700 to-amber-800 text-white shadow-md',
    default: 'bg-white text-slate-600 border-2 border-slate-200 shadow-sm'
  };

  return (
    <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-semibold transition-smooth hover:scale-105 ${variants[variant]}`}>
      <span className="text-base">{emoji}</span>
      <span>{label}</span>
    </div>
  );
}